import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import "./YourNestAdmin.css";
import { API_CONFIG } from '../../config/api';

export const YourNestAdmin = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('users');
  const [userList, setUserList] = useState([]);
  const [artistList, setArtistList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [poiList, setPoiList] = useState([]);
  const [showPoiForm, setShowPoiForm] = useState(false);
  const [poiFormData, setPoiFormData] = useState({
    tour_name: '',
    tour_type: 'atelier',
    tour_phone: '',
    tour_location: '',
    tour_location_lat: '',
    tour_location_lng: '',
    tour_open_days: '1,2,3,4,5',
    tour_open_time: '10:00-18:00',
    tour_website: '',
    tour_description: ''
  });

  const handleLogout = () => {
    document.cookie = `admin_id=; path=/;`;
    alert('로그아웃 되었습니다.');
    navigate('/yournest-login');
  };

  // 일반 회원 목록 조회
  const fetchUsers = async () => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/admin_get_users`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error('회원 목록 조회 실패');
      const data = await response.json();
      setUserList(data.users);
    } catch (error) {
      console.error('회원 목록 조회 실패:', error);
      alert('회원 목록을 불러오는데 실패했습니다.');
    }
  };

  // 예술가 회원 목록 조회
  const fetchArtists = async () => {
    try {
        const response = await fetch(`${API_CONFIG.MAIN}/admin_get_artists`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error('예술가 목록 조회 실패');
      const data = await response.json();
      setArtistList(data.artists);
    } catch (error) {
      console.error('예술가 목록 조회 실패:', error);
      alert('예술가 목록을 불러오는데 실패했습니다.');
    }
  };

  const handleApprove = async (orderId) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/admin_update_order_status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_id: orderId,
          status: 'completed'
        })
      });
  
      if (!response.ok) {
        throw new Error('주문 승인 실패');
      }
  
      const data = await response.json();
      if (data.isSuccess) {
        alert('주문이 승인되었습니다.');
        fetchOrders(); // 주문 목록 새로고침
      }
    } catch (error) {
      console.error('주문 승인 중 오류 발생:', error);
      alert('주문 승인에 실패했습니다.');
    }
  };
  
  const handleReject = async (orderId) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/admin_update_order_status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_id: orderId,
          status: 'canceled'
        })
      });
  
      if (!response.ok) {
        throw new Error('주문 거절 실패');
      }
  
      const data = await response.json();
      if (data.isSuccess) {
        alert('주문이 거절되었습니다.');
        fetchOrders(); // 주문 목록 새로고침
      }
    } catch (error) {
      console.error('주문 거절 중 오류 발생:', error);
      alert('주문 거절에 실패했습니다.');
    }
  };

  // 예약/결제 목록 조회
  const fetchOrders = async () => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/admin_get_orders`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error('주문 목록 조회 실패');
      const data = await response.json();
      setOrderList(data.orders);
    } catch (error) {
      console.error('주문 목록 조회 실패:', error);
      alert('주문 목록을 불러오는데 실패했습니다.');
    }
  };

  // POI 목록 조회
  const fetchPoi = async () => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/admin_get_poi`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error('POI 목록 조회 실패');
      const data = await response.json();
      setPoiList(data.pois);
    } catch (error) {
      console.error('POI 목록 조회 실패:', error);
      alert('POI 목록을 불러오는데 실패했습니다.');
    }
  };

  // POI 등록
  const handlePoiSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/admin_create_poi`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(poiFormData)
      });

      if (!response.ok) throw new Error('POI 등록 실패');
      const data = await response.json();
      
      if (data.isSuccess) {
        alert('POI가 등록되었습니다.');
        setShowPoiForm(false);
        fetchPoi();
        setPoiFormData({
          tour_name: '',
          tour_type: '',
          tour_phone: '',
          tour_location: '',
          tour_location_lat: '',
          tour_location_lng: '',
          tour_open_days: '1,2,3,4,5',
          tour_open_time: '10:00-18:00',
          tour_website: '',
          tour_description: ''
        });
      }
    } catch (error) {
      console.error('POI 등록 실패:', error);
      alert('POI 등록에 실패했습니다.');
    }
  };

  useEffect(() => {
    if (activeTab === 'users') {
      fetchUsers();
      fetchArtists();
    } else if (activeTab === 'orders') {
      fetchOrders();
    } else if (activeTab === 'poi') {
      fetchPoi();
    }
  }, [activeTab]);

  // POI 관리 탭 UI
  const renderPoiTab = () => (
    <div className="admin__poi-block">
      <button 
        className="admin__add-poi-btn"
        onClick={() => setShowPoiForm(!showPoiForm)}
      >
        새 POI 등록
      </button>

      {showPoiForm && (
        <form onSubmit={handlePoiSubmit} className="admin__poi-form">
          <div className="form-group">
            <label>구분 *</label>
            <select 
              value={poiFormData.tour_type}
              onChange={e => setPoiFormData({...poiFormData, tour_type: e.target.value})}
              required
            >
              <option value="atelier">아뜰리에</option>
              <option value="studio">스튜디오</option>
              <option value="residency">레지던시</option>
              <option value="museum">박물관</option>
              <option value="gallery">미술관</option>
            </select>
          </div>

          <div className="form-group">
            <label>이름 *</label>
            <input
              type="text"
              value={poiFormData.tour_name}
              onChange={e => setPoiFormData({...poiFormData, tour_name: e.target.value})}
              required
            />
          </div>

          <div className="form-group">
            <label>전화번호 *</label>
            <input
              type="text"
              value={poiFormData.tour_phone}
              onChange={e => setPoiFormData({...poiFormData, tour_phone: e.target.value})}
              required
            />
          </div>


          <div className="form-group">
            <label>주소 *</label>
            <input
              type="text"
              value={poiFormData.tour_location}
              onChange={e => setPoiFormData({...poiFormData, tour_location: e.target.value})}
              required
            />
          </div>

          <div className="form-group">
            <label>위도 *</label>
            <input
              type="number"
              step="any"
              value={poiFormData.tour_location_lat}
              onChange={e => setPoiFormData({...poiFormData, tour_location_lat: e.target.value})}
              required
            />
          </div>

          <div className="form-group">
            <label>경도 *</label>
            <input
              type="number"
              step="any"
              value={poiFormData.tour_location_lng}
              onChange={e => setPoiFormData({...poiFormData, tour_location_lng: e.target.value})}
              required
            />
          </div>

          <div className="form-group">
            <label>운영시간</label>
            <input
              type="text"
              value={poiFormData.tour_open_time}
              onChange={e => setPoiFormData({...poiFormData, tour_open_time: e.target.value})}
              placeholder="10:00-18:00"
            />
          </div>

          <div className="form-group">
            <label>웹사이트</label>
            <input
              type="text"
              value={poiFormData.tour_website}
              onChange={e => setPoiFormData({...poiFormData, tour_website: e.target.value})}
            />
          </div>

          <div className="form-group">
            <label>소개</label>
            <textarea
              value={poiFormData.tour_description}
              onChange={e => setPoiFormData({...poiFormData, tour_description: e.target.value})}
            />
          </div>

          <button type="submit">등록</button>
          <button type="button" onClick={() => setShowPoiForm(false)}>취소</button>
        </form>
      )}

      <table className="admin__table">
        <thead>
          <tr>
            <th>구분</th>
            <th>이름</th>
            <th>주소</th>
            <th>운영시간</th>
            <th>등록일</th>
          </tr>
        </thead>
        <tbody>
          {poiList.map(poi => (
            <tr key={poi.id}>
              <td>{poi.tour_type}</td>
              <td>{poi.tour_name}</td>
              <td>{poi.tour_location}</td>
              <td>{poi.tour_open_time}</td>
              <td>{new Date(poi.timestamp).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="admin">
      <div className="admin__tab-block">
        <div 
          className={`admin__tab-block-item${activeTab === 'users' ? '--active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          회원 관리
        </div>
        <div 
          className={`admin__tab-block-item${activeTab === 'orders' ? '--active' : ''}`}
          onClick={() => setActiveTab('orders')}
        >
          예약/결제 관리
        </div>
        <div 
          className={`admin__tab-block-item${activeTab === 'poi' ? '--active' : ''}`}
          onClick={() => setActiveTab('poi')}
        >
          POI 관리
        </div>
        <div className="admin__tab-block-title">
          YourNest 관리자
        </div>
        <div className="admin__tab-block-item">
          <button onClick={handleLogout}>로그아웃</button>
        </div>
      </div>

      {activeTab === 'users' ? (
        <div className="admin__users-block">
          <h3>일반 회원 목록</h3>
          <table className="admin__table">
            <thead>
              <tr>
                <th>ID</th>
                <th>이름</th>
                <th></th>
                <th>이메일</th>
                <th>전화번호</th>
                <th>가입일</th>
              </tr>
            </thead>
            <tbody>
              {userList.map(user => (
                <tr key={user.id}>
                  <td>{user.user_login_id}</td>
                  <td>{user.user_name}</td>
                  <td></td>
                  <td>{user.user_email}</td>
                  <td>{user.user_phone}</td>
                  <td>{new Date(user.timestamp).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3>예술가 회원 목록</h3>
          <table className="admin__table">
            <thead>
              <tr>
                <th>ID</th>
                <th>이름</th>
                <th>소속</th>
                <th>이메일</th>
                <th>전화번호</th>
                <th>가입일</th>
              </tr>
            </thead>
            <tbody>
              {artistList.map(artist => (
                <tr key={artist.id}>
                  <td>{artist.artist_login_id}</td>
                  <td>{artist.artist_name}</td>
                  <td>{artist.artist_company}</td>
                  <td>{artist.artist_email}</td>
                  <td>{artist.artist_phone}</td>
                  <td>{new Date(artist.timestamp).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : activeTab === 'orders' ? (
        <div className="admin__orders-block">
          <table className="admin__table">
            <thead>
              <tr>
                <th>주문번호</th>
                <th>투어명</th>
                <th>예약자</th>
                <th>예약일시</th>
                <th>인원</th>
                <th>결제금액</th>
                <th>결제상태</th>
                <th>주문일시</th>
                <th>조치상태</th>
              </tr>
            </thead>
            <tbody>
              {orderList.map(order => (
                <tr key={order.order_id}>
                  <td>{order.order_id}</td>
                  <td>{order.tour_name}</td>
                  <td>{order.user_name}</td>
                  <td>{new Date(order.reservation_date).toLocaleDateString()} {order.reservation_time}</td>
                  <td>{order.number_of_people}명</td>
                  <td>{order.payment_amount.toLocaleString()}원</td>
                  <td>
                    {order.payment_status === 'completed' ? '결제완료' :
                    order.payment_status === 'pending' ? '결제대기' :
                    order.payment_status === 'canceled' ? '취소됨' : order.payment_status}
                  </td>
                  <td>{new Date(new Date(order.created_at).getTime() + 9 * 60 * 60 * 1000).toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' })}</td>
                  <td>
                  {order.payment_status === 'pending' && (
                    <>
                      <button 
                        className="admin-button"
                        onClick={() => handleApprove(order.order_id)}
                      >
                        승인
                      </button>
                      <button 
                        className="admin-button reject"
                        onClick={() => handleReject(order.order_id)}
                      >
                        거절
                      </button>
                    </>
                  )}
            </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        renderPoiTab()
      )}
    </div>
  );
};
